import React from "react";
import { Icon, IconName } from "../icon";

import "./badge.css";

export const Badge = ({
	value,
	iconName,
	className,
	children,
}: React.PropsWithChildren<{
	value?: string;
	iconName?: IconName;
	className?: string;
}>) => (
	<div className={`badge__container ${className || ""}`}>
		{children}
		{value || iconName ? (
			<div className={`badge ${iconName ? "badge--is-icon" : ""}`}>
				{iconName ? <Icon iconName={iconName} /> : value}
			</div>
		) : null}
	</div>
);
Badge.displayName = "Badge";
